<!--  -->
<template>
  <div>

    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px" class="searchForm">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Category3">
              <el-select v-model="queryCondition.category3Code" :disabled="category3List.length>1?false:true" clearable style="width:100%" placeholder="请选择">
                <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Sponser">
              <el-input disabled v-model="queryCondition.sponsorCode" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="ASL Group">
              <el-select v-model="queryCondition.aslGroupCode" clearable disabled filterable placeholder="请选择" style="width:100%">
                <el-option :key="index" v-for="(item,index) in aslGroupCodeList" :label="item.aslGroupName" :value="item.aslGroupCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品名">
              <el-input v-model="queryCondition.productName" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="药品一级分类">
              <el-select v-model="queryCondition.medicineLevelOneGrade" clearable filterable placeholder="请选择" style="width:100%">
                <el-option :key="index" v-for="(item,index) in medicineLevelOneGradeList" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="WHO药品等级">
              <el-select v-model="queryCondition.whoMedicineGrade" clearable filterable placeholder="请选择" style="width:100%">
                <el-option :key="index" v-for="(item,index) in whoMedicineGradeList" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="有效成分">
              <el-select v-model="queryCondition.effectiveComponents" clearable filterable placeholder="请选择" style="width:100%">
                <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产厂家">
              <el-input v-model="queryCondition.producer" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row>
            <el-col :span="6">
                <el-form-item label="Category3" >
                   <el-select v-model="queryCondition.category3Code" :disabled="category3List.length>1?false:true" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="Sponser" >
                    <el-input disabled v-model="queryCondition.sponsorCode" clearable style="width:100%"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="ASL Group" >
                    <el-select v-model="queryCondition.aslGroupCode" clearable disabled filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in aslGroupCodeList" :label="item.aslGroupName" :value="item.aslGroupCode"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="商品名" >
                   <el-input v-model="queryCondition.productName" clearable style="width:100%"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="药品一级分类" >
                    <el-select v-model="queryCondition.medicineLevelOneGrade" clearable  filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in medicineLevelOneGradeList" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="WHO商品等级" >
                    <el-select v-model="queryCondition.medicineLevelTwoGrade" clearable  filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in whoMedicineGradeList" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="有效成分" >
                    <el-select v-model="queryCondition.effectiveComponents" clearable  filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
          </el-row> -->
        <el-row type="flex" justify="center" align="middle" style="margin-top:8px;">
          <el-button size="mini" @click="queryData" type="primary">查询</el-button>
          <el-button size="mini" @click="onReset" type="primary">重置</el-button>
        </el-row>
      </el-form>
    </div>

    <el-row align="middle">
      <el-button size="mini" type="primary" @click="selectData">选择</el-button>
    </el-row>
    <el-table :data="tableData" style="width: 100%;margin-top:8px;" border @selection-change="selectionChange">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="category3Name" label="Category3" width="100"> </el-table-column>
      <el-table-column prop="sponsorName" label="Sponsor" width="180"> </el-table-column>
      <el-table-column prop="aslGroupName" label="ASL Group" width="120"> </el-table-column>
      <el-table-column prop="productName" label="商品名" width="180"> </el-table-column>
      <el-table-column prop="medicineLevelOneGrade" label="药品一级分类"> </el-table-column>
      <el-table-column prop="whoMedicineGrade" label="WHO药品等级"> </el-table-column>
      <el-table-column prop="effectiveComponents" label="有效成分"> </el-table-column>
      <el-table-column prop="producer" label="生产厂家"> </el-table-column>
      <el-table-column prop="specification" label="规格"> </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import proteinDrug from "@/api/rmcProtein/drug";
import aslApi from "@/api/rmcProtein/asl";


export default {
  data() {
    return {
      multipleSelection: [],
      aslGroupCodeList: [],
      medicineLevelOneGradeList: [],
      whoMedicineGradeList: [],
      effectiveComponentsList: [],
      getRadioVal: "",
      tableData: [],
      category3List: [],
      saveCate3: "",
      queryCondition: {
        category3Code: "",
        sponsorCode: "",
        aslGroupCode: JSON.parse(sessionStorage.getItem('rmcDrugDosageInfo')).aslGroupCode,
        medicineLevelOneGrade: "",
        // medicineLevelTwoGrade: "",
        whoMedicineGrade: "",
        effectiveComponents: "",
        productName: "",
        status: "PASS",
        pageNum: 1,
        pageSize: 15,
      },
      totalCount: "",
    };
  },

  components: {},
  created() {
    let detailInfo = JSON.parse(sessionStorage.getItem('rmcDrugDosageInfo'))
    if (JSON.stringify(detailInfo) != '{}') {
      console.log("穿过来的数据===", detailInfo)
      this.queryCondition.sponsorCode = detailInfo.sponsorName
      this.getAslGroup(detailInfo.sponsorCode)
    }
    this.$set(this.queryCondition, 'medicineLevelOneGrade', '抗生素')
    this.getDrugGrade()
    this.getdCategory3()
    this.queryData()
  },
  mounted() { },

  computed: {},

  methods: {
    selectData() {
      this.$emit("close", this.multipleSelection)
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    getAslGroup(id) {
      aslApi.aslGroup({}, id).then((res) => {
        if (res.code == 200) {
          this.aslGroupCodeList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'protein'
        })
        if (this.category3List.length == 1) {
          this.queryCondition.category3Code = this.category3List[0].key
          this.saveCate3 = this.category3List[0].key
          this.queryCondition.category3Name = this.category3List[0].object
        }
      })
    },
    queryData() {
      proteinDrug.getDrugList(this.queryCondition).then((res) => {
        this.tableData = res.resultData
        this.totalCount = res.totalCount
      })
    },
    // 单选获取的数据
    getTemplateRow(index, row) {
      this.getRadioVal = row.invoiceHeaderId
    },
    onReset() {
      this.queryCondition = {
        category3Code: this.saveCate3,
        sponsorCode: JSON.parse(sessionStorage.getItem('rmcDrugDosageInfo')).sponsorName,
        aslGroupCode: JSON.parse(sessionStorage.getItem('rmcDrugDosageInfo')).aslGroupCode,
        medicineLevelOneGrade: "",
        // medicineLevelTwoGrade: "",
        whoMedicineGrade: "",
        effectiveComponents: "",
        productName: "",
        status: "PASS",
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData()
    },
    noUpdate() {
      console.log("确认无更新")
      this.close()
    },
    close() {
      this.$emit("close")
    },
    getDrugGrade() {
      proteinDrug.queryNatureForSelect().then((res) => {
        // 有效成分
        res.data.effectiveComponentsList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.effectiveComponentsList.push(obj)
        })
        // 药品一级分类
        res.data.medicineLevelOneGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.medicineLevelOneGradeList.push(obj)
        })
        // WHO药品等级
        res.data.whoMedicineGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.whoMedicineGradeList.push(obj)
        })
      })
    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  }
}

</script>
<style>
.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
  padding: 10px 20px 10px;
  box-sizing: border-box;
}
</style>
<style  scoped>
</style>